export function getProgressBarPercentage(projects: number): number {
    let progressBarPercentage = projects * 2;
    if (progressBarPercentage > 100) progressBarPercentage = 100;
    return progressBarPercentage;
}